<span
  class="status {{ statusClass }}"
>
  {{ label }}
</span>